import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=20b31b9b&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=20b31b9b&prod&lang=scss&scoped=true&"
import style1 from "./Index.vue?vue&type=style&index=1&id=20b31b9b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b31b9b",
  null
  
)

export default component.exports